namespace $.$$ {

	export class $shm_hitalama_map_book_tools extends $.$shm_hitalama_map_book_tools {

		drawing_checked( next?: boolean ) {
			return this.tool_checked( 'drawing', next )
		}

		rect_checked( next?: boolean ) {
			return this.tool_checked( 'rect', next )
		}

		circle_checked( next?: boolean ) {
			return this.tool_checked( 'circle', next )
		}

		tool_checked( mode: string, next?: boolean ) {
			if( next !== undefined ) this.tool_mode( next ? mode : '' )
			return this.tool_mode() === mode
		}

	}

}
